export default "__VITE_ASSET__Btvc64cG__"